/* eslint-disable max-len */
const iwIl = {
  CancellationRequest: 'בקשת ביטול',
  Heading: 'אנא הזינו את המידע הבא. כל השדות נדרשים.',
  Note: 'צריכים לבטל את ההזמנה שלכם? אנחנו כאן כדי לעזור. מלאו את השדות מטה אודות ההזמנה שתרצו לבטל.',
  PartnerNote:
    'תודה! אנו נותנים קדימות לבקשות עם תאריך הנסיעה הסמוך ביותר. אם עדיין לא אישרנו את הביטול שלכם לפני תאריך הנסיעה, חשוב שתדעו שאנו עובדים על כך. לא נדרשת שום פעולה מהצד שלכם בנידון.',
  SubmitNote:
    'בשל כמות שיבושי הנסיעות חסרת התקדים, ייתכן שיתקיימו עיכובים בעיבודי החזרים. אנו מתנצלים על ההמתנה ומעריכים את סבלנותכם.',
  Disclaimer:
    'חשוב: השתמשו בטופס זה עבור תאריכי נסיעה המתקיימים עד ה-31 בדצמבר, 2021.',
  Itin: 'מספר הנסיעה (11-15 תווים הנמצאים בהזמנה שלכם או באימייל האישור שקיבלתם)',
  EmailAddress: 'כתובת האימייל בה עשיתם שימוש כדי להזמין את ההזמנה הזו',
  PhoneNumber: 'מספר הטלפון בו עשיתם שימוש כדי להזמין את ההזמנה הזו',
  Reason: 'סיבה',
  Submit: 'המשך',
  Success: 'קיבלנו את בקשתכם',
  Failed: 'אנו מתנצלים',
  InProgress: 'אנו עובדים על כך',
  TryAgain: 'חזרה אחורה',
  PhoneErrorMessage: 'אנא הזינו מספר טלפון תקין',
  EmailErrorMessage: 'אנא הזינו כתובת אימייל תקינה',
  ItinErrorMessage: 'אנא הזינו מספר תקין.',
  ResponseEligibleHeader: 'מצאנו את הנסיעה שלכם',
  ResponseEligibleSubmit: 'כן, בטל את ההזמנות שלי',
  ResponseEligibleNeverMind: 'לא, אל תבטל',
  ResponseOnlyLodgingWithRefund:
    'הזמנות לינה הזכאיות להחזר: {x}. אם תבחרו לבטל, ההחזר יועבר אל אמצעי התשלום המקורי שבאמצעותו שילמתם.',
  ResponseOnlyLodgingWithCoupon:
    'הזמנות לינה הזכאיות לקבלת שובר בצורת קופון: {x}. אם תבחרו לבטל, אנו ננפיק לכם קופון בשווי סכום הרכישה המקורי.',
  ResponseOnlyLodgingInEligible:
    'הזמנות לינה שאינן זכאיות לביטול חינם: {x}. אם תבחרו לבטל, מדיניות הביטול הרגילה של שותפי הלינה שלנו תחול על ההזמנה.',
  ResponseLodgingWithOtherLob:
    'מדיניות הביטול של שותפי הנסיעות שלנו תחול על כל ההזמנות הקשורות לנסיעה זו.',
  ResponseNoLodgingWithOtherLob:
    'מדיניות הביטול של שותפי הנסיעות שלנו תחול על כל ההזמנות הקשורות לנסיעה זו.',
  ResponseAlreadyCancelled:
    'הזמנות לינה שכבר בוטלו: {x}. בשל כמות שיבושי הנסיעות חסרת התקדים, ייתכן שיתקיימו עיכובים בעיבודי החזרים. אם יש לכם שאלות נוספות, אנא צרו קשר עם תמיכת הלקוחות שלנו.',
  ResponseNoFlexAvailable:
    'הזמנות לינה שלא זכאיות להחזר או שובר: {x}. אם תבטלו כעת, מדיניות הביטול הרגילה של שותפי הלינה שלנו תחול על ההזמנה. מדיניות הביטול יכולה להשתנות. בדקו 8 ימים לפני הנסיעה שלכם כדי לקרוא את מדיניות הביטול המעודכנת ביותר.',
  ResponseInvalidDuplicateItinerary:
    'נראה שכבר שלחתם את הבקשה הזו. אנו נותנים קדימות לבקשות עם תאריך הנסיעה הסמוך ביותר. אם עדיין לא אישרנו את הביטול שלכם לפני תאריך הנסיעה, חשוב שתדעו שאנו עובדים על כך. לא נדרשת שום פעולה מהצד שלכם בנידון.',
  ResponseElligibleConfirmation: 'האם תרצו לבטל את ההזמנות שלכם?',
  ResponseInvalidUnknown:
    'לא הצלחנו למצוא את מספר הנסיעה או ההזמנה הזה. אנא בדקו את המספר ונסו שוב. תוכלו למצוא את המספר באימייל שקיבלתם מאיתנו כאשר ביצעתם את הזמנתכם לראשונה.',
  ResponseInvalidItineraryNotFound:
    'לא הצלחנו למצוא את מספר הנסיעה או ההזמנה הזה. אנא בדקו את המספר ונסו שוב. תוכלו למצוא את המספר באימייל שקיבלתם מאיתנו כאשר ביצעתם את הזמנתכם לראשונה.',
  ResponseInvalidTripMoreThanSevenDays: 'אין באפשרותנו לטפל בבקשה שלכם.',
  ResponseInvalidTripIsLcc:
    'חברת התעופה איתה אתם אמורים לטוס מנהלת את כל הביטולים. אנא צרו קשר עם חברת התעופה ישירות. לקבלת מידע נוסף, אנא התחברו לחשבון שלכם כדי לצפות בפרטי הנסיעה שלכם בצורה מקוונת. ייתכן שיחלפו עד 72 שעות עד שביטולים המעובדים כעת יופיעו כמבוטלים בעמוד פרטי הנסיעה שלכם.',
  ResponseInvalidTripIsTicketless:
    'חברת התעופה איתה אתם אמורים לטוס מנהלת את כל הביטולים. אנא צרו קשר עם חברת התעופה ישירות. לקבלת מידע נוסף, אנא התחברו לחשבון שלכם כדי לצפות בפרטי הנסיעה שלכם בצורה מקוונת. ייתכן שיחלפו עד 72 שעות עד שביטולים המעובדים כעת יופיעו כמבוטלים בעמוד פרטי הנסיעה שלכם.',
  ResponseInvalidItinerary: 'אנו לא מזהים את מספר הנסיעה שלכם. אנא נסו שוב.',
  ResponseInvalidStatus: 'אירעה שגיאה. אנא נסו שוב.',
  ResponseInvalidEmail:
    'אנו לא מזהים את כתובת האימייל הזו או שהיא אינה תואמת לכתובת האימייל בה נעשה שימוש במסגרת הנסיעה הזו. אנא וודאו שמדובר באותה כתובת אימייל בה השתמשתם בעת ההזמנה.',
  ResponseInvalidPhone:
    'אנו לא מזהים את מספר הטלפון שלכם. אנא וודאו שמדובר באותו המספר בו השתמשתם בעת ההזמנה.',
  ResponseTripHasLccFlight:
    'אנו יכולים לבטל חלק מההזמנות שלכם, אבל לא את כולם. עבור ההזמנות שאנו לא יכולים לבטל, אנא צרו קשר עם הספק ישירות. תוכלו להיעזר בעמוד פרטי הנסיעה המקוון שלכם כדי לראות אילו מבין ההזמנות עדיין ממתינות לביטול. ייתכן שיחלפו עד 72 שעות עד שביטולים המעובדים כעת יופיעו כמבוטלים בעמוד פרטי הנסיעה שלכם.',
  ResponseErrorTripWithin24Hrs:
    'אין באפשרותנו לטפל בביטול שלכם משום שנותרו פחות מ-24 שעות למועד הנסיעה שלכם. לקבלת מידע נוסף, אנא התחברו לחשבון שלכם כדי לצפות בפרטי הנסיעה שלכם בצורה מקוונת.',
  ResponseInvalidTripInCruise:
    'אנו לא יכולים לקבל בקשות לביטולי שייט באמצעות הטופס הזה. אנא התחברו אל החשבון שלכם ובטלו באופן מקוון בהזמנה שלכם.',
};
export default iwIl;
